import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceAccountGuard } from './route-guards/service-account.guard';
import { OperationsComponent } from './operations/operations.component';

@Component({
  selector: 'app-blank',
  template: ``
})
export class BlankComponent {}

const routes: Routes = [
  {
    path: '',
    component: BlankComponent
  },
  {
    path: 'sso',
    component: BlankComponent,
    data: {
      allowSmallScreens: true
    },
    children: [
      {
        path: 'featurebase',
        component: BlankComponent,
        data: {
          feature: 'featurebase'
        }
      }
    ]
  },
  // Lazy load ops module
  {
    path: 'ops',
    loadChildren: () => import('./operations/operations.module').then((m) => m.OperationsModule),
    canActivate: [ServiceAccountGuard],
    data: {
      isroute: true
    }
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  declarations: [BlankComponent],
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
